module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/hand_pedal-48c5d7a6807fece794e7a95f73295e13.svg";